var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{staticClass:"award-selection-rule-modal",attrs:{"name":"award-selection-rule-modal","width":`80%`,"height":`80%`,"pivotY":0.5},on:{"before-close":_vm.handlerBeforeClose,"before-open":_vm.handlerBeforeOpen,"opened":_vm.handlerOpened}},[_c('div',[_vm._v(" 수상작 선정 규정 모달 "),_c('terms-component')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }